var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath23108(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.75,
    height: 38.75,
    viewBox: "0 0 38.75 38.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23108",
    "data-name": "Path 23108",
    d: "M536.679,242.187A19.375,19.375,0,1,1,517.3,222.812a19.373,19.373,0,0,1,19.375,19.375m-3.75,0A15.625,15.625,0,1,0,517.3,257.812a15.619,15.619,0,0,0,15.625-15.625m-12.188,10h-6.875a.938.938,0,0,1-.937-.938v-1.874a.938.938,0,0,1,.937-.938h.938v-5h-.938a.938.938,0,0,1-.937-.938v-1.875a.938.938,0,0,1,.937-.937h5a.938.938,0,0,1,.938.937v7.813h.937a.938.938,0,0,1,.938.938v1.874a.938.938,0,0,1-.938.938m-.156-17.5a3.281,3.281,0,1,1-3.281-3.281,3.281,3.281,0,0,1,3.281,3.281",
    transform: "translate(-497.929 -222.812)",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath23108);
export default __webpack_public_path__ + "static/media/Path 23108.14ebe1c6929238f92dc1d3b12dbca3b1.svg";
export { ForwardRef as ReactComponent };